import { render } from "./PanelChart.vue?vue&type=template&id=54581cb5&scoped=true"
import script from "./PanelChart.vue?vue&type=script&lang=js"
export * from "./PanelChart.vue?vue&type=script&lang=js"

import "./PanelChart.vue?vue&type=style&index=0&id=54581cb5&lang=css&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54581cb5"]])

export default __exports__